export default function() {
  return (
    <img src={require('../../assets/images/image-2.png')} />
  );
}